import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCase = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 20,
	viewBox: "0 0 12 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.48691 3.62196L3.33672 3.16422H3.56519L3.48691 3.62196Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.71902 3.16422H3.56519L3.63505 2.75574L3.71902 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.81811 3.16422L3.78526 3.48648L3.71902 3.16422H3.81811Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.02998 3.16422H3.81811L3.9334 2.0332L4.02998 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.15378 3.16422L4.08361 3.79233L4.02998 3.16422H4.15378Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.34704 3.16422H4.15378L4.23175 2.46631L4.34704 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.34704 3.16422H4.5301L4.38196 3.37564L4.34704 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26876 3.48648L5.14942 3.16422H5.29849L5.26876 3.48648Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.47279 3.16422H5.29849L5.39016 2.17072L5.47279 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.58239 3.16422L5.5095 3.60553L5.47279 3.16422H5.58239Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.66833 3.16422H5.58239L5.62884 2.883L5.66833 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.79514 3.16422L5.74818 3.73279L5.66833 3.16422H5.79514Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.95689 3.16422H5.79514L5.86957 2.26309L5.95689 3.16422Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04556 3.16422L5.98891 3.49468L5.95689 3.16422H6.04556Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04556 3.16422L6.10819 2.79883L6.22759 3.16422H6.04556Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.77054 1.6883V2.70643H7.77249C7.77249 2.91169 7.9393 3.08 8.14705 3.08H10.3259C11.1346 3.08 11.791 3.73481 11.791 4.5415V16.2314C11.791 16.7677 11.5009 17.2368 11.0688 17.4911C11.0782 17.5564 11.083 17.6231 11.083 17.691C11.083 18.4653 10.4539 19.093 9.67781 19.093C8.9022 19.093 8.27349 18.4663 8.27246 17.6929H3.72762C3.72658 18.4663 3.09781 19.093 2.3223 19.093C1.54617 19.093 0.916992 18.4653 0.916992 17.691C0.916992 17.6231 0.921829 17.5564 0.931166 17.4911C0.499086 17.2369 0.208984 16.7677 0.208984 16.2314V4.54355C0.208984 3.73685 0.86534 3.08206 1.67396 3.08206C1.87971 3.08206 2.04843 2.9158 2.04843 2.70848V1.6883C2.04843 1.25519 2.40029 0.90625 2.83238 0.90625H6.98665C7.42074 0.90625 7.77054 1.25725 7.77054 1.6883ZM7.08559 2.0542C7.08559 1.815 6.89119 1.62109 6.65149 1.62109H3.17829C2.93851 1.62109 2.74414 1.815 2.74414 2.0542V3.88927C2.74414 4.12848 2.93851 4.32238 3.17829 4.32238H6.65149C6.89119 4.32238 7.08559 4.12848 7.08559 3.88927V2.0542ZM6.47062 8.31905H8.47462C8.60227 8.31905 8.72362 8.37035 8.81212 8.45861C8.90062 8.54687 8.95207 8.67209 8.95207 8.79935C8.95207 8.92661 8.90062 9.04979 8.81212 9.14009C8.72167 9.23039 8.60017 9.27971 8.47462 9.27971H7.46437C7.21132 9.27971 6.97057 9.38231 6.78952 9.56087C6.61057 9.74153 6.50977 9.98579 6.50977 10.2403V13.1325C6.50977 13.2598 6.45817 13.383 6.36982 13.4733C6.27922 13.5636 6.15787 13.6129 6.03232 13.6129H6.01177C5.88419 13.6129 5.76281 13.5616 5.67433 13.4733C5.58586 13.3849 5.53442 13.2598 5.53442 13.1325V10.2424C5.53442 9.98783 5.43359 9.74357 5.25664 9.56297C5.0797 9.38231 4.83689 9.27971 4.58588 9.27761H3.57562C3.44804 9.27761 3.32665 9.22631 3.23818 9.13805C3.14971 9.04979 3.09826 8.92457 3.09826 8.79731C3.09826 8.67005 3.14971 8.54687 3.23818 8.45657C3.3287 8.36627 3.45011 8.31701 3.57562 8.31701H5.58379C5.47268 7.90853 5.2196 7.55135 4.87187 7.31117C4.5221 7.07105 4.10029 6.96431 3.68261 7.00739C3.26287 7.05047 2.87399 7.24547 2.58386 7.55135C2.29169 7.85717 2.11886 8.25953 2.0921 8.68235L2.08594 8.80349L2.09623 12.5517C2.09623 12.8308 2.20733 13.0996 2.4028 13.2988C2.59828 13.4979 2.8637 13.6087 3.14147 13.6087C3.41924 13.6087 3.68467 13.4979 3.88013 13.2988C4.0756 13.0996 4.18672 12.8329 4.18672 12.5517L4.19288 10.2424C4.19288 10.189 4.19905 10.1377 4.21757 10.0885C4.23608 10.0392 4.26284 9.99401 4.29988 9.95705C4.33486 9.91805 4.38013 9.88931 4.42745 9.86879C4.47476 9.84827 4.52621 9.83801 4.5797 9.83801C4.63321 9.83801 4.68259 9.84827 4.73197 9.86879C4.78135 9.88931 4.82456 9.92009 4.85954 9.95705C4.89452 9.99605 4.92332 10.0392 4.94183 10.0885C4.96036 10.1377 4.96858 10.1911 4.96652 10.2424V13.1346C4.96652 13.4137 5.07763 13.6827 5.27311 13.8817C5.46857 14.0809 5.734 14.1916 6.01177 14.1916H6.03232C6.30802 14.1916 6.57562 14.0809 6.77107 13.8817C6.96652 13.6827 7.07752 13.4158 7.07752 13.1346V10.2424C7.07752 10.189 7.08382 10.1377 7.10227 10.0885C7.12072 10.0392 7.14757 9.99401 7.18462 9.95705C7.21957 9.91805 7.26487 9.88931 7.31212 9.86879C7.35952 9.84827 7.41097 9.83801 7.46437 9.83801C7.51792 9.83801 7.56727 9.84827 7.61662 9.86879C7.66597 9.88931 7.70932 9.92009 7.74427 9.95705C7.77922 9.99605 7.80802 10.0392 7.82662 10.0885C7.84507 10.1377 7.85332 10.1911 7.85122 10.2424L7.85947 12.5517C7.85947 12.8308 7.97062 13.0996 8.16607 13.2988C8.36152 13.4979 8.62702 13.6087 8.90467 13.6087C9.18247 13.6087 9.44797 13.4979 9.64342 13.2988C9.83887 13.0996 9.94987 12.8329 9.94987 12.5517L9.96022 8.80349L9.95407 8.68439C9.92527 8.26361 9.75247 7.86335 9.46027 7.55753C9.17017 7.25165 8.78122 7.06283 8.36557 7.01765C7.94797 6.97457 7.52812 7.07921 7.18252 7.31735C6.83482 7.55543 6.58372 7.90853 6.46852 8.31701L6.47062 8.31905Z",
			fill: "currentColor"
		})
	]
});
export default SvgCase;
